import { occUrl, occFetch } from "~/app/api/occ/occFetch";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";

export const FccAction = {
  BannerClick: "BANNERCLICK",
  IconClick: "ICONCLICK",
  DownloadExcel: "DOWNLOADEXCEL",
  DownloadCsv: "DOWNLOADCSV",
  CreateQuoteForFcc: "CREATEQUOTEFORFCC",
  CreateQuoteForAll: "CREATEQUOTEFORALL",
  BulkEntry: "BULKENTRY",
  Login: "LOGIN",
  AddToWishlist: "ADDTOWISHLIST",
  AddToQuote: "ADDTOQUOTE",
  SearchBar: "SEARCHBAR",
  TreeTabSeries: "TABSERIESVALUE",
  TreeTabHierarchy: "TABHIERARCHYVALUE",
  TreeTabPlant: "TABPLANTVALUE",
  CustomerRelevant: "CUSTOMERRELEVANT",
  SelectProduct: "SELECTPRODUCT",
} as const;

const url = occUrl("/fcc/trackAction");

type ActionType = (typeof FccAction)[keyof typeof FccAction];
type Data =
  | ActionType
  | { actionType: ActionType; actionContent?: string; quantity?: number; netPrice?: number; priceUnit?: number };

export function trackFccAction(data: Data) {
  if (userHasPermission(Permission.CanOpenFCC)) {
    occFetch(url, {
      body: JSON.stringify(getBody(data)),
      /*
      The keepalive option can be used to allow the request to outlive the page.
      Fetch with the keepalive flag is a replacement for the Navigator.sendBeacon() API.

      Source: https://developer.mozilla.org/en-US/docs/Web/API/fetch#parameters
       */
      keepalive: true,
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
    });
  }
}

function getBody(data: Data) {
  if (typeof data === "string") {
    return { actionType: data };
  }
  return data;
}
